import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import * as ApiHelper from "../../../ApiHelper"
import Util from "../../../Util"
import Moment from "moment"
import { TableLayout } from "../../../components"
import { ToastContainer, ToastMessage } from "react-toastr"
import { confirmAlert } from "react-confirm-alert"
class TableDigitalizados extends Component {
  constructor() {
    super()
    this.toastFactory = React.createFactory(ToastMessage.animation)
    this.delete = this.delete.bind(this)
    this.getArquivo = this.getArquivo.bind(this)
    this.state = {
      showLoad: false
    }
  }

  addAlert(title, message) {
    this.container.error(title, message, {
      timeOut: 5000,
      extendedTimeOut: 3000
    })
  }
  delete(id) {
    confirmAlert({
      title: "Confirme a remoção",
      message: "Tem certeza que deseja deletar?",
      buttons: [
        {
          label: "Sim",
          onClick: () =>
            ApiHelper.deleteContratoDigitalizado(id, error => {
              if (error) {
                this.addAlert("", error.message)
              } else {
                this.props.onDelete()
              }
            })
        },
        {
          label: "Não"
        }
      ]
    })
  }
  getArquivo(url) {
    var tempLink = document.createElement("a")
    tempLink.href = url
    tempLink.setAttribute("target", "_blank")
    document.body.appendChild(tempLink)
    tempLink.click()
    document.body.removeChild(tempLink)
  }
  render() {
    var tableHeaders = ["Nome do arquivo", "Adicionado em", "Ações"]
    var buttons = [
      {
        title: "Digitalizar contrato",
        link: "/digitalizados/" + this.props.match.params.id + "/create",
        icon: "control_point"
      },
      {
        title: "Digitalizações deletadas",
        link: "/digitalizados/" + this.props.match.params.id + "/trash",
        icon: "delete"
      }
    ]
    return (
      <div>
        <ToastContainer
          ref={input => {
            this.container = input
          }}
          toastMessageFactory={this.toastFactory}
          className="toast-top-right"
          preventDuplicates={true}
        />
        <TableLayout
          headerButtons={buttons}
          sizeClass={this.props.sizeClass}
          backgroundColor={this.props.backgroundColor}
          title={this.props.title}
          subtitle={this.props.subtitle}
          filter={this.props.filter}
          searchLabel="Pesquisar contrato digitalizado"
        >
          <table className="table table-hover">
            <thead className="text-warning">
              <tr>
                {tableHeaders.map((header, key) => {
                  return <th key={key}>{header}</th>
                })}
              </tr>
            </thead>
            <tbody>
              {this.props.rows.map((row, key) => {
                return (
                  <tr key={key}>
                    {
                      <td className="col-md-10">
                        {Util.getLastPathComponent(row.nome)}
                      </td>
                    }
                    <td className="col-sm-2">
                      {Moment(row.created_at).format("D/MM/Y")}
                    </td>
                    <td className="col-sm-3 td-actions text-right">
                      <button
                        onClick={event => this.getArquivo(row.nome)}
                        type="button"
                        rel="tooltip"
                        title="Vizualizar contrato digitalizado"
                        className="btn btn-info btn-simple btn-xs"
                      >
                        <i className="material-icons">local_printshop</i>
                      </button>
                      <button
                        type="button"
                        rel="tooltip"
                        title="Remover contrato digitalizado"
                        onClick={() => this.delete(row.id)}
                        className="btn btn-danger btn-simple btn-xs"
                      >
                        <i className="material-icons">close</i>
                      </button>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </TableLayout>
      </div>
    )
  }
}
export default withRouter(TableDigitalizados)



// WEBPACK FOOTER //
// ./src/views/contratos/digitalizados/TableDigitalizados.js